import { render } from "./Carret.vue?vue&type=template&id=27d1405b"
const script = {}

import exportComponent from "../../../../../../../projects/loyalzilla_admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/icons/Carret.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "27d1405b"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('27d1405b', __exports__)) {
    api.reload('27d1405b', __exports__)
  }
  
  module.hot.accept("./Carret.vue?vue&type=template&id=27d1405b", () => {
    api.rerender('27d1405b', render)
  })

}


export default __exports__